import React from 'react'; 


const Error =({mensajes})=> (

    <p className="alert alert-danger">{mensajes}</p>
);

export default Error;